import routerOptions0 from "/Users/rodrigolemos/meistrari/identity-provider/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.6_@types+node@25.0.10_@vue+compiler-sfc@3.5.27_cac@6.7.14_com_q4vxxbrctlvrgte35dbnrud6mm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}